import {
  JwtType,
  LoginMethod,
  UserRole,
  UserStatus,
} from '../enums/auth.enums';
import { MlbAbbreviation } from '../enums/batrack.enums';
import { Competition } from '../enums/team.enums';
import { LanguageCode } from '../enums/translation';
import { Nullable } from './common/i-generics';
import { ICombinedPermissions } from './i-permissions';
import { IUserSettings } from './i-user';

/**
 * basic: default
 * impostor: admin is viewing the app as if logged in as another user
 * super: admin is viewing the app with access to data from all teams/users
 */
export enum SessionMode {
  Basic = 'basic',
  Impostor = 'impostor',
  Super = 'super',
}

export interface IAuthToken
  extends ICombinedPermissions, Partial<IUserSettings> {
  method: LoginMethod;

  version: string;
  email: string;
  expiresAt: string;
  refreshExpiresAt: string;

  machineID: string;
  machineNickname?: string;

  role: UserRole;
  session: string;
  status: UserStatus;

  teamID: string;
  team: string;
  abbreviation: Nullable<MlbAbbreviation>;

  league: Competition;
  extraLeagues?: Competition[];

  type: JwtType;
  userID: string;
  mode: SessionMode;

  language?: LanguageCode;

  wsID: string;
}

export interface IUserCRUD extends IAuthToken {
  password: string;
  token: string;
}
